<template>
  <div class="flex flex-col gap-9 w-full h-full flex-1">
    <div class="flex flex-col gap-3.5">
      <div class="flex flex-row gap-3 items-center justify-between w-full">
        <RouterLink :to="{ name: 'ProfileView' }" class="flex flex-row gap-3">
          <div
            class="rounded-full border-[3px] bg-PRIMARY border-SECONDARY flex flex-row items-center justify-center w-10 h-10"
          >
            <p class="text-lg font-semibold">{{ gameStore.level }}</p>
          </div>
          <div class="flex flex-col gap-0.5 whitespace-nowrap">
            <p class="text-sm font-semibold">
              {{ gameStore.getLevelName() }} {{ userStore.firstName }}
            </p>
            <div class="flex flex-row gap-2.5 items-center">
              <div class="w-full bg-WHITE h-1">
                <div
                  class="bg-gradient-to-b from-[#ECD800] to-[#FFA339] h-full transition-all duration-300"
                  :style="{ width: finalProgress + '%' }"
                ></div>
              </div>
              <p class="text-GREY text-[10px] pe-6">{{ currentProgress }}/{{ totalProgress }}</p>
            </div>
          </div>
        </RouterLink>

        <div v-if="walletAddress" class="relative">
          <pow-button @click="toggleWalletDropdown" id="ton-connect" primary size="sm">
            {{ walletAddress.substring(0, 6) }}...{{ walletAddress.slice(-4) }}
          </pow-button>
          <div
            ref="walletDropdownRef"
            id="wallet-dropdown"
            v-if="walletDropdownShow"
            class="absolute top-12 bg-PRIMARY right-0 rounded-lg border border-BORDER flex items-start flex-col"
          >
            <button
              class="px-4 py-3 text-WHITE text-xs font-medium flex items-center gap-2 min-w-max"
              @click="copyAddress"
            >
              <font-awesome-icon size="" class="white-icon" :icon="['fas', 'copy']" />
              Copy Adress
            </button>
            <div class="w-4/5 h-px bg-white opacity-15 mx-auto"></div>
            <button
              class="px-4 py-3 text-WHITE text-xs font-medium flex items-center gap-2 min-w-max"
              @click="disconnectWallet"
            >
              <font-awesome-icon size="" class="red-icon" :icon="['fas', 'ban']" />
              Disconnect
            </button>
          </div>
        </div>
        <pow-button v-else id="ton-connect" @click="openWalletModal" primary size="sm">
          <p class="whitespace-nowrap">{{ $t('Buttons.connectWallet') }}</p>
        </pow-button>
        <!--<TelegramConnectButtonTest primary size="sm"></TelegramConnectButtonTest>-->
      </div>
      <div class="flex flex-row gap-3 items-center">
        <pow-container class="flex-1 justify-start">
          <template #content>
            <div class="flex flex-row gap-3 py-3 px-2 items-center">
              <p class="text-GREY text-xs">{{ $t('EarnView.profitPerHours') }}</p>
              <div class="gap-1.5 flex flex-row">
                <img class="w-5 shadow" src="@/assets/icons/token-2.svg" />
                <p class="text-sm font-semibold">+{{ nFormatter(gameStore.tokenPerHour) }}</p>
              </div>
            </div>
          </template>
        </pow-container>
        <pow-button @click="openDailyRewardDrawer" primary size="sm" class="flex-2"
          ><template #icon>
            <img src="@/assets/icons/gift-box.svg" />
          </template>
          <p class="whitespace-nowrap">{{ $t('EarnView.dailyReward') }}</p>
        </pow-button>
      </div>
    </div>
    <div class="flex flex-col h-full gap-9 items-center justify-center flex-1">
      <div class="flex items-end gap-1">
        <!-- <PowIcon class="w-8 h-8" name="token-2" type="vector"></PowIcon> -->
        <img src="../assets/icons/token-2.svg" class="h-8 w-8 object-contain" />
        <div class="flex flex-col">
          <p class="text-WHITE text-xs">{{ $t('EarnView.yourCoin') }}</p>
          <p class="text-WHITE text-[28px] leading-8 font-semibold">
            {{ gameStore.totalTokenPrintable }}
          </p>
        </div>
      </div>
      <div class="flex items-center w-full justify-between my-auto">
        <div class="flex flex-col gap-3">
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['sword']" title="Sword"></SkinPreviewBox>
          </router-link>
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['hat']" title="Hat"></SkinPreviewBox>
          </router-link>
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['shirts']" title="Shirts"></SkinPreviewBox>
          </router-link>
        </div>
        <div
          @click="earn"
          id="main-mine"
          class="w-[230px] h-[230px] rounded-full p-3 custom-bg-1"
          :class="animationClass"
        >
          <div class="w-full h-full rounded-full p-6 custom-bg-2 flex flex-col items-center">
            <PirateFigure :image="character.image"></PirateFigure>
          </div>
        </div>
        <div class="flex flex-col gap-3">
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['pants']" title="Pants"></SkinPreviewBox>
          </router-link>
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['shoes']" title="Shoes"></SkinPreviewBox>
          </router-link>
          <router-link :to="{ name: 'EditCharacterView' }" class="flex items-center justify-center">
            <SkinPreviewBox :item="gameStore.activeSkins['belt']" title="Belt"></SkinPreviewBox>
          </router-link>
        </div>
      </div>
      <div class="flex flex-col gap-4 w-full">
        <div class="w-full flex items-center justify-between">
          <div class="flex gap-2 rounded-lg bg-PRIMARY pe-3 ps-2 items-center w-fit h-9">
            <img src="../assets/icons/energy-2.svg" class="h-full w-6 object-contain" />
            <p class="text-xs">
              <span>{{ gameStore.remainingClicks }}</span> / <span>{{ gameStore.maxClicks }}</span>
            </p>
          </div>
          <button
            v-if="false"
            class="flex gap-1 rounded-lg bg-PRIMARY pe-2 ps-1 items-center w-fit h-9"
            @click="router.push({ name: 'BoostsView' })"
          >
            <img src="../assets/icons/boost.svg" class="h-full w-6 object-contain" />
            <p class="text-xs">{{ $t('Buttons.boost') }}</p>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="showToast"
      class="fixed bottom-32 w-72 gap-3 left-1/2 -translate-x-1/2 text-base font-medium text-BLACK h-12 flex items-center justify-center rounded-lg bg-white"
    >
      <font-awesome-icon icon="fa-solid fa-check" class="green-icon" />
      Account Address Copied
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import PowButton from '@/components/PowButton.vue'
import TelegramConnectButtonTest from '@/components/TelegramConnectButtonTest.vue'
import PowContainer from '@/components/PowContainer.vue'
import DailyRewardDrawer from '@/components/drawers/DailyRewardDrawer.vue'
import PirateFigure from '@/components/PirateFigure.vue'
import PowIcon from '@/components/PowIcon.vue'
import SkinPreviewBox from '@/components/SkinPreviewBox.vue'
import { openBottomDrawer } from '@/composables/bottomdrawer'
import { useUserStore } from '@/stores/user'
import { useGameStore } from '@/stores/game'
import { nFormatter } from '@/utils'

import { useTonAddress, useTonConnectModal, useTonConnectUI } from 'ton-ui-vue'

import { saveWallet } from '@/services'
import { onClickOutside, useClipboard } from '@vueuse/core'

const router = useRouter()
const userStore = useUserStore()
const gameStore = useGameStore()

const currentProgress = ref(1)
const walletDropdownRef = ref(null)
const walletDropdownShow = ref(false)
const totalProgress = ref(10)
const finalProgress = ref((currentProgress.value / totalProgress.value) * 100)
const character = gameStore.getActiveCharacter()
const showToast = ref(false)
const referals = ref([])

const walletAddress = useTonAddress()
const { open, close, isOpen } = useTonConnectModal()
const { tonConnectUI } = useTonConnectUI()

const { copy } = useClipboard()

const openDailyRewardDrawer = () => {
  openBottomDrawer(DailyRewardDrawer, {
    size: 'lg',
    props: {},
    emits: {}
  })
}

const total = ref(2000)
const balance = ref(2000)
const animationClass = ref()

const earnAnimation = (clientX, clientY) => {
  const div = document.createElement('div')
  const mainMine = document.getElementById('main-mine')

  div.innerHTML = '+1'
  div.setAttribute('class', 'earned-title')
  div.style = `left: ${clientX}px; top: ${clientY}px; z-index:10`
  animationClass.value = 'shake-animation'
  mainMine.appendChild(div)
  setTimeout(() => {
    div.remove()
    animationClass.value = ''
  }, 1000)
}

const earn = (ev) => {
  const clientX = ev.clientX
  const clientY = ev.clientY
  if (gameStore.remainingClicks > 0) {
    earnAnimation(clientX, clientY)
    gameStore.clickCharacter()
  }
}

const toggleWalletDropdown = () => {
  if (walletDropdownShow.value) {
    walletDropdownRef.value = false
  } else {
    walletDropdownShow.value = true
  }
}

onClickOutside(walletDropdownRef, () => {
  walletDropdownShow.value = false
})

watch(walletAddress, (newX) => {
  if (walletAddress.value) {
    saveWallet({ address: walletAddress.value })
  }
})

const openWalletModal = async () => {
  open()
}

const disconnectWallet = async () => {
  tonConnectUI.value.disconnect()
  walletDropdownShow.value = false
}

const copyAddress = () => {
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, 1500)
  copy(walletAddress.value)
  walletDropdownShow.value = false
}
</script>
<style>
.custom-bg-1 {
  background: linear-gradient(180deg, #3c89d6 0%, #571976 100%);
  box-shadow: 0px 1px 3px 0px #ffffff inset;
}
.custom-bg-2 {
  background: linear-gradient(180deg, #351281 0%, #59389f 100%);
  box-shadow: 0px 0px 40px 0px #00000024 inset;
}
</style>

<style>
@keyframes earn-animation {
  0% {
    transform: translateY(10%);
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translateY(-1000%);
    opacity: 0;
  }
}
.earned-title {
  position: absolute;
  animation: earn-animation 2s 1;
  animation-direction: alternate;
  color: white;
  font-size: 16pt;
  font-weight: 700;
  user-select: none;
  z-index: 1;
}

.shake-animation .earn-shake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 1s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
